<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

* {
  margin: 0;
  padding: 0;
  outline: none;
  -webkit-box-sizing: content-box;
  -moz-box-sizing: content-box;
  box-sizing: content-box;
  font-family: "Microsoft YaHei", 微软雅黑, "MicrosoftJhengHei", 华文细黑,
    STHeiti, MingLiu;
  color: #9197a7;
}

html {
  overflow-y: scroll;
  height: 100%;
  scroll-behavior: smooth;
}

body {
  margin: 0;
  padding: 0;
  height: 100%;
}

html,
body {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

i {
  font-style: normal;
}

img {
  border: 0;
}

input {
  outline: none;
  background-color: #fff;
}

/*清除chrome表单自动填充的背景色*/
textarea {
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
  border: 1px solid #d0d0d0;
  resize: none;
  outline: none;
}

a:link {
  color: #666666;
  text-decoration: none;
}

a:visited {
  color: #666666;
  text-decoration: none;
}

a:hover {
  color: #000000;
  text-decoration: none;
}

a:active {
  color: #000000;
  text-decoration: none;
}

ul,
ol,
li {
  list-style: none;
}

.hide {
  display: none;
}

.white {
  color: #fff;
}

.green {
  color: green;
}

.red {
  color: red;
}

#app {
  margin: 0 auto;
  height: 100%;
  min-height: 100%;
}

.wrap {
  margin: 0 auto;
  width: 100%;
}

.relative {
  position: relative;
}

.banner {
  margin: 0 auto;
  width: 100%;
  position: relative;
}

.mr_1200 {
  margin: 0 auto;
  width: 1200px;
}

.mr_1500 {
  margin: 0 auto;
  width: 1500px;
}

.mr_1280 {
  margin: 0 auto;
  width: 1201px;
}

.mr_1300 {
  margin: 0 auto;
  width: 1360px;
}
.mr_1325 {
  width: 1325px;
  margin: 0 auto;
}
.hand {
  cursor: pointer;
}

.flex {
  display: flex;
}

.text_overflow {
  /*强制文本在一行内显示*/
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.word_break {
  overflow: hidden;
  display: -webkit-box;
  /* 将对象作为弹性伸缩盒子模型显示 */
  -webkit-line-clamp: 2;
  /* 行数，值可以改，表示展示X行后多余的缩略展示 */
  -webkit-box-orient: vertical;
  /* 设置或检索伸缩盒对象的子元素的排列方式 */
  word-break: break-all;
}

.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
  background: none !important;
}

.el-pagination.is-background .el-pager li:not(.disabled).active {
  color: #333 !important;
}
</style>


// WEBPACK FOOTER //
// src/App.vue